import Fab from '@mui/material/Fab';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';

type MultiFabProps = {
  ariaLabel: string;
  icon: React.ReactNode;
  actions: {
    name: string;
    icon: React.ReactNode;
    onClick: () => void;
  }[];
};
const MultiFab = (props: MultiFabProps) => {
  switch (props.actions.length) {
    case 0:
      return null;
    case 1:
      return (
        <Fab
          aria-label={props.actions[0].name}
          onClick={() => props.actions[0].onClick()}
          color="secondary"
        >
          {props.icon}
        </Fab>
      );
    default:
      return (
        <SpeedDial
          ariaLabel={props.ariaLabel}
          icon={props.icon}
          color="secondary"
        >
          {props.actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              slotProps={{ tooltip: { title: action.name } }}
              onClick={() => {
                action.onClick();
              }}
            />
          ))}
        </SpeedDial>
      );
  }
};

export default MultiFab;
